import { render, staticRenderFns } from "./wb-lang.vue?vue&type=template&id=3e61d1c3&scoped=true"
import script from "./wb-lang.vue?vue&type=script&lang=js"
export * from "./wb-lang.vue?vue&type=script&lang=js"
import style0 from "./wb-lang.vue?vue&type=style&index=0&id=3e61d1c3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e61d1c3",
  null
  
)

export default component.exports